import React from 'react';

import { css } from '@emotion/css';
import { Remirror } from '@remirror/react';
import { getThemeVar } from 'remirror';

import { VisualEditorMenuBar } from '../MenuBar/Menu';
import { IModeEditorProps } from '../types';
import { useWrapperEditor } from '../utils';

import '@remirror/styles/all.css';
import '../styles.css';

export const VisualEditor: React.FC<IModeEditorProps> = ({
  onChange,
  placeholder
}) => {
  const { visual, setMarkdown } = useWrapperEditor();

  return (
    <div
      className={
        'relative flex flex-col px-4 pb-3 min-h-[350px] max-h-[700px] w-full rounded-md border border-input bg-white text-base placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm shadow-none text-base-foreground mt-0 placeholder:text-base-mutedForeground overflow-auto resize-y'
      }
    >
      <Remirror
        manager={visual.manager}
        placeholder={placeholder}
        autoRender="end"
        onChange={({ helpers, state }) => {
          const markdown = helpers.getMarkdown(state);
          onChange(markdown);
          setMarkdown(markdown);
        }}
        classNames={[
          'focus-visible:outline-none min-h-[240px]',
          css`
            &.ProseMirror {
              p,
              h3,
              h4 {
                margin-top: ${getThemeVar('space', 2)};
                margin-bottom: ${getThemeVar('space', 2)};
              }

              h1,
              h2 {
                margin-bottom: ${getThemeVar('space', 3)};
                margin-top: ${getThemeVar('space', 3)};
              }
            }
          `
        ]}
      >
        <VisualEditorMenuBar />
      </Remirror>
    </div>
  );
};
